import { Moment } from 'moment';
import PickingStatus from '@/dossier/constants/PickingStatus';
import { isAnyOf, isPresent } from '@/shared/utils/typescript';
import Location from '@/vehicle/models/Location';
import JobItemType from '../constants/JobItemType';
import StockStatus from '../constants/StockStatus';
import { JobId } from './AbstractJob';

export interface JobItemPartsData {
  id: JobItemId;
  stockStatus: StockStatus | null;
  pickingStatus: PickingStatus | null;
}

export interface JobPartsData {
  location: string;
  items: Array<JobItemPartsData>;
}

export interface JobItemId {__jobItemId: number}

export default class JobItem {
  id!: JobItemId;
  description: string | null = null;
  code: string | null = null;
  jobId: JobId | null = null;
  type!: JobItemType;
  createdOn!: Moment;
  deletedOn: Moment | null = null;
  quantity: number | null = null;
  stockStatus: StockStatus | null = null;
  stockLocation: Location | null = null;
  pickingStatus: PickingStatus | null = null;
  isRecent = false;

  getTitle(): string {
    if (isAnyOf(this.type, JobItemType.PART, JobItemType.SERVICE) && isPresent(this.quantity)) return `${this.quantity} x ${this.description}`;
    return this.description ?? '';
  }

  updateWith(data: Partial<JobItem>): void {
    Object.assign(this, data);
  }

  hasStatusChanges(data: JobItemPartsData): boolean {
    return this.pickingStatus !== data.pickingStatus || this.stockStatus !== data.stockStatus;
  }
}
